import React from "react";
import { PopupModalModel } from "../../models/PopupModalModel";
import { disableBodyScroll } from "../../utils/dom";

interface MediaModalState {
  content: PopupModalModel;
  isVisible: boolean;
  isSmall: boolean;
}

export interface PopupModalNativeProps {
  content: PopupModalModel;
  isVisible: boolean;
  close: () => void;
}
class PopupModalNative extends React.Component<
  PopupModalNativeProps,
  MediaModalState
> {
  constructor(props) {
    super(props);

    this.state = {
      content: this.props.content,
      isVisible: this.props.isVisible,
      isSmall: true,
    };
  }

  componentWillMount() {
    disableBodyScroll();
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (e): boolean => {
    if (this.state.isVisible && e.keyCode === 27) {
      this.props.close();
    }

    return true;
  };

  renderContent() {
    const { isVisible, content, isSmall } = this.state;
    const { text, title } = content;

    return (
      <div className={`popup__wrapper ${isVisible ? "is-visible" : ""}`}>
        {!isSmall && title ? (
          <div className="popup__header">
            <h2>{title}</h2>
          </div>
        ) : null}
        <div className="popup__inner">
          <div className="popup__content-scroll">
            {title ? <h1>{title}</h1> : null}
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </div>
          {isSmall ? (
            <i
              data-close="true"
              className="popup__close"
              onClick={(e) => {
                this.props.close();
              }}
              role="button"
            >
              <span>Close</span>
            </i>
          ) : null}
        </div>
        {!isSmall ? <div className="popup__footer" /> : null}
      </div>
    );
  }

  render() {
    const { isVisible, content, isSmall } = this.state;

    return (
      <div
        className={`popup__container--accessory-pack popup__container ${
          isSmall ? "popup__container--is-small" : ""
        } ${isVisible ? "is-visible" : ""}`}
        onClick={(e: any) => {
          if (e.target.classList.contains("popup__container"))
            this.props.close();
        }}
      >
        {content ? this.renderContent() : null}
      </div>
    );
  }
}

export default PopupModalNative;
